import React from 'react'

import { Chip } from '@mui/material'
import { ContaAzulInfoStatus } from 'models/AccountsPayable'
import { rgba } from 'polished'

import { getStatusComplete } from 'components/Status/Status.styles'

import { theme } from 'styles/theme'

interface ContaAzulStatusChipProps {
  status?: ContaAzulInfoStatus | null
}

// Chip padronizado do status de sincronização com o Conta Azul. Reutiliza o domínio de status
// do sistema (getStatusComplete) para os estados de sincronização e cai num chip neutro
// "Não sincronizado" quando o registro ainda não tem conta_azul_info.
const ContaAzulStatusChip: React.FC<ContaAzulStatusChipProps> = ({
  status
}) => {
  const style = status
    ? getStatusComplete(status)
    : {
        color: rgba(theme.palette.neutral[700], 0.3),
        fontColor: theme.palette.neutral[400],
        label: 'Não sincronizado'
      }

  return (
    <Chip
      label={style.label}
      sx={{
        backgroundColor: style.color,
        color: style.fontColor,
        height: '25px',
        fontWeight: 600,
        fontSize: '14px'
      }}
    />
  )
}

export default ContaAzulStatusChip
